import { render, staticRenderFns } from "./AccountRecordDetail.vue?vue&type=template&id=46fcda30&scoped=true"
import script from "./AccountRecordDetail.vue?vue&type=script&lang=js"
export * from "./AccountRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./AccountRecordDetail.vue?vue&type=style&index=0&id=46fcda30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fcda30",
  null
  
)

export default component.exports